<div *ngIf="course$ | async as course">
	<div class="banner" [ngStyle]="{'background-image': course.banner && course.banner?.url ? 'url(\'' + course.banner?.url + '\')' : 'none'}">
		<div class="banner-content-wrapper">
			<div class="banner-content">
				<h1 id="page-title" tabindex="-1">
					<span class="h2">Online Symposium</span>
					<span class="h1" [innerHTML]="course.title|simpleMd"></span>
				</h1>
			</div>
		</div>
	</div>

	<div class="content-row">
		<div class="container">
			<div class="row">
				<div class="col">
					<div id="course-content">
						<div *ngIf="course.overview" [innerHTML]="course.overview.textContent"></div>

						<ol id="content-list" class="accordion course-accordion" *ngIf="course">
							<li class="card course-card" *ngFor="let content of course.lectures; index as idx; trackBy: trackLesson">
								<div [id]="'course-anchor--'+content.url_slug" tabindex="-1"></div>
								<app-lesson [courseId]="course.system_id" [lecture]="content" layout="card" [lessonNumber]="idx + 1"></app-lesson>
							</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
